import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import React from "react";
import { ReactComponent as ObjectiveIcon } from "Assets/Icons/Classroom/ObjectiveIcon.svg";

const ContestAllQues = () => {
  const columns = [
    { label: "Name of the Problem", accessor: "name" },
    { label: "Type", accessor: "type" },
    {
      accessor: "score",
      label: "Score",
    },
    {
      accessor: "status",
      label: "Status",
    },
    {
      accessor: "actions",
      label: "Actions",
    },
  ];

  return (
    <>
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((column, i) => (
                <TableCell key={i}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {[...Array(10)]?.map((item, i) => {
              return (
                <TableRow hover key={`bodyRow${i}`}>
                  {columns.map((column, i) => {
                    return (
                      <TableCell key={`bodyCol${i}`}>
                        {column?.accessor == "type" ? (
                          <PrimaryIcon icon={ObjectiveIcon} fill={false} />
                        ) : column?.accessor == "score" ? (
                          <Typography color="secondary.light">
                            0.0/50
                          </Typography>
                        ) : column?.accessor == "status" ? (
                          <Typography
                            sx={(theme) => ({
                              background: theme.palette.border.grey,
                              padding: "6px 16px",
                              borderRadius: "8px",
                            })}
                            color="secondary.light"
                          >
                            Unsolved
                          </Typography>
                        ) : column?.accessor == "actions" ? (
                          <Button variant="contained">Solve</Button>
                        ) : (
                          <Typography color="secondary.light">
                            Q1. Frame work for weight loss
                          </Typography>
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography>I have completed my test</Typography>
        <Button variant="outlined" color="error">
          End Test
        </Button>
      </Box>
    </>
  );
};

export default ContestAllQues;
